import { useStore } from 'vuex';
import Fitting from '@/models/Fitting';
import { useI18n } from 'vue-i18n';

export default function useAddToBasket()
{
    const store = useStore();
    const { t } = useI18n({ useScope: 'global' });

    class AddToBasket
    {
        async handle()
        {
            store.commit('overlay/setText', t('overlay.adding_to_basket'));

            // Add a dependency code to the prepared basket lines (if set)
            const context = store.state.basket.addToBasketContext;
            const dependencyCode = context.dependencyCode;
            const basketLines = context.basketLines.map(bl => ({
                ...bl,
                dependency_code: dependencyCode,
            }));

            const saved = await store.dispatch('basket/saveLines', basketLines);
            console.log('These lines have been added to the basket:', basketLines);
            return saved;
        }
    }

    return AddToBasket;
}
